import { IconButton, Tooltip } from "@govlaunch/web";
import React from "react";
import BookmarkIcon from "~/components/icons/Collections/BookmarkIcon";
import { ISelfieQuery } from "~/lib/queries/__generated__/SelfieQuery.generated";
import { IListAllCollectionsQuery } from "~/src/components/collection/graphql/__generated__/ListCollectionsQuery.generated";
import { useIntl } from "react-intl";

interface ICollectionBookmarkButtonProps {
  collection: IListAllCollectionsQuery["listAllCollections"]["items"][0];
  selfie: ISelfieQuery["selfie"] | null;
  signInModal: any;
  onToggleBookmark: any;
}

export default function CollectionBookmarkButton({
  collection,
  selfie,
  signInModal,
  onToggleBookmark,
}: ICollectionBookmarkButtonProps) {
  const intl = useIntl();

  return (
    <Tooltip
      bg="teal.800"
      label={intl.formatMessage({
        defaultMessage: "Save collection",
        id: "b+ygF6",
      })}
      p={2}
    >
      <IconButton
        position="absolute"
        top="4px"
        right="4px"
        width="20px"
        height="28px"
        aria-label={intl.formatMessage({
          defaultMessage: "Bookmark",
          id: "Rs4kCE",
        })}
        color="gray.400"
        zIndex={1}
        size="xs"
        _hover={{
          color: "teal.800",
        }}
        data-intercom-target="Bookmark collection"
        onClick={(event: React.SyntheticEvent) => {
          event.preventDefault();
          if (selfie) {
            onToggleBookmark(collection);
          } else {
            signInModal.open();
          }
        }}
        icon={() => <BookmarkIcon viewerDidBookmark={collection.viewerDidBookmark} notBookmarkedColor="none" />}
      />
    </Tooltip>
  );
}
